var map = {
	"./1920x1080.png": 98,
	"./1920x10801.jpg": 417,
	"./1920x10802.jpg": 418,
	"./1920x10803.png": 419,
	"./7P7A8473.jpg": 420,
	"./DTSA-2022-LOGO.png": 421,
	"./asset.png": 422,
	"./background1.png": 423,
	"./background2.png": 424,
	"./imagegrid/1.png": 425,
	"./imagegrid/2.png": 426,
	"./imagegrid/3.png": 427,
	"./imagegrid/4.png": 428,
	"./imagegrid/7.png": 429,
	"./imagegrid/8.png": 430,
	"./landscape.jpg": 431,
	"./logo.png": 432,
	"./logo/3.png": 99,
	"./logo/DTD-2025-LOGO-White.png": 433,
	"./logo/DTD-2025-LOGO.png": 434,
	"./logo/DTD-2026-LOGO.png": 77,
	"./logo/DTD-2026.png": 100,
	"./logo/dark.png": 435,
	"./logo/ksa.png": 436,
	"./logo/logoblack copy 2.png": 437,
	"./logo/logoblack.png": 438,
	"./logo/logowhite.png": 439,
	"./logo/me.png": 440,
	"./logo/uk.png": 441,
	"./logo/white.png": 442,
	"./logo1.png": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 416;